
import errorReporting from '../common/errorReporting';
import Config from 'Config'
import StackTrace from "stacktrace-js";

export const reportError = (error) => {
    console.log('Unexpected fatal Error', error);

    let errorLog = '';
    const crashReportingEnabled = Config.crashReporting.enabled || false;
    const env = location.hostname || '';
    if (crashReportingEnabled) {
        StackTrace.fromError(error).then(err => {
            if (err) {
                err.map((stackFrame) => {
                    errorLog += "columnNumber: " + stackFrame.columnNumber + "\r\n";
                    errorLog += "fileName: " + stackFrame.fileName + "\r\n";
                    errorLog += "functionName: " + stackFrame.functionName + "\r\n";
                    errorLog += "lineNumber: " + stackFrame.lineNumber + "\r\n";
                    errorLog += "--------------------------------------------------" + "\r\n";
                })
            }

            errorLog += "url: " + window.location.href + "\r\n";
            errorLog += "browser: " + window.navigator.userAgent + "\r\n";
            errorLog += "date: " + new Date() + "\r\n";
            errorLog += "error: " + error.toString() + "\r\n";

            errorReporting.reportError('Error in ' + env + ': ' + error, errorLog);
        });
    }
}